import React from "react";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import EmailTemplate from "../components/EmailTemplate";
import { ThemeProvider } from "../context/ThemeContext";

const AppLayout = () => {
  return (
    <ThemeProvider>
      <Header />
      <main>
        <Outlet />
      </main>
      <EmailTemplate />
      <Footer />
    </ThemeProvider>
  );
};

export default AppLayout;
